import { toast } from 'sonner';

import { ApiRequestError } from './errors.ts';

// 403 codes that mean the session now belongs to another kind of account,
// e.g. a curator signed in from another tab: every app shares one API cookie.
const OTHER_ACCOUNT = new Set(['not_candidate_account', 'forbidden']);

const reload = { label: 'Reload', onClick: () => window.location.reload() };

/**
 * Toasts an error that is not about a field. A changed or ended session makes
 * the whole page stale, so it stays up with a Reload button; reloading lands
 * on the right screen (sign-in, or the wrong-account notice). Needs a
 * <Toaster /> mounted on the page.
 */
export function notifyError(e: unknown, fallback: string) {
  if (e instanceof ApiRequestError && e.status === 401) {
    toast.error('You are signed out', {
      id: 'session',
      description: 'Your session ended, maybe from another tab. Reload to sign in again.',
      duration: Infinity,
      action: reload,
    });
  } else if (e instanceof ApiRequestError && e.status === 403 && OTHER_ACCOUNT.has(e.code)) {
    toast.error('You are signed in as a different account', {
      id: 'session',
      description:
        'Another account signed in on this browser, maybe in another tab. Reload to continue.',
      duration: Infinity,
      action: reload,
    });
  } else {
    toast.error(e instanceof ApiRequestError ? e.message : fallback);
  }
}
